import { categories } from "@/mocks/homeData";

export default function Track() {
  return (
    <section id="track" className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex items-end justify-between gap-4">
          <div>
            <p className="text-sm font-medium tracking-wide text-primary-600">栏目赛道 · TRACKS</p>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-4xl">瓜分赛道</h2>
          </div>
          <p className="hidden max-w-xs text-sm leading-6 text-foreground-600 sm:block">按话题类型分门别类，想追哪一类直接进，省得大海捞针。</p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {categories.map((c) => (
            <a
              key={c.id}
              href="#latest"
              className="group relative overflow-hidden rounded-2xl border border-background-200/70 bg-background-50 p-6 transition-all hover:-translate-y-1 hover:border-primary-200"
            >
              <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-background-100 text-3xl">
                {c.emoji}
              </div>
              <h3 className="mt-5 font-heading text-lg font-bold text-foreground-900">{c.name}</h3>
              <p className="mt-2 min-h-[48px] text-sm leading-6 text-foreground-600">{c.desc}</p>
              <div className="mt-4 flex items-center justify-between">
                <span className="inline-flex items-center gap-1 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-800">
                  <i className="ri-article-line" aria-hidden="true"></i>今日 {c.count} 条
                </span>
                <span className="flex h-8 w-8 items-center justify-center rounded-full bg-background-200/70 text-foreground-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                  <i className="ri-arrow-right-line text-sm" aria-hidden="true"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}